/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */
import { status } from '../../../../enums/statusEnum';
import { statusBorderColor, statusColor, statusFontColor } from '../../../../enums/statusColorEnum';
import { IconColorPalette, IconVehicleDefault, ModelIcon } from '../../../../components/buttons/IconButtons';
import RowCardText from '../../../../components/RowCardText';
import NotInformation from '../../../../components/NotInformation';
import ContractVehicleDetailsCardsApp from '../Functionality/ContractVehicleDetailsCardsApp';
import { CustomCheckbox } from '../../../../components/CustomCheckbox';
import { permissionObj } from '../../../../Helpers/permission';
import { EMPTY_VALUES, getFullName } from '../../../../Apis/functions';
import CustomTooltip from '../../../../components/CustomTooltip';
import CustomChip from '../../../../components/CustomChip';
import CustomCardGridGeneral from '../../../../components/CustomCardGridGeneral';
import {forwardRef} from "react";

const ContractVehicleDetailsCards = forwardRef(({selectedList, contractorId, isAllChecked, setSelectedList,
                                         modified, setModified, setIsAllChecked, subView },containerHeightCardsRef) => {

    const {
        t, // Translation function
        DEV,
        permission,
        elementRefTab1,
        results,
        pagination,
        handleCheckboxChange,
        handleDeleteAll,
        renderVehicleButton,
    } = ContractVehicleDetailsCardsApp({
        selectedList,
        setSelectedList,
        modified,
        setModified,
        isAllChecked,
        setIsAllChecked,
        subView
    });

    return (
        <div className='m-3' ref={containerHeightCardsRef}>
            {results?.content?.length > 0 ? (
                <>
                    {(contractorId ||
                        DEV ||
                        permission?.includes(permissionObj.WEB_CONTRACTOR_CONTRACT_MANAGE_VEHICLES)) && (
                        <div className={'col-12 p-0'}>
                            <div className={'d-flex justify-content-between'}>
                                <CustomCheckbox
                                    id={'cb_cvdc_all_checked'}
                                    trans={'de_/_select_all'}
                                    name={'isAllChecked'}
                                    checked={isAllChecked}
                                    onChange={(e) => {
                                        handleDeleteAll(e);
                                    }}
                                />
                            </div>
                        </div>
                    )}
                    <div className={'col-12 p-0'}>
                        <div className='panelTables px-1 row' ref={elementRefTab1}>
                            {results?.content?.map((character, index) => {
                                return (
                                    <div className='col-sm-12 col-md-6 col-lg-6 col-xl-4 mb-3'>
                                        <CustomCardGridGeneral
                                           selected={selectedList.includes(character?.id)}
                                            head={
                                                <>
                                                    <div
                                                        className='h-144px img-container img-background-primary-20 d-flex flex-column justify-content-center
                                align-items-center gap-2 flex-fill align-self-stretch position-relative overflow-hidden'
                                                    >
                                                        {character?.selfie && (
                                                            <img
                                                                src={`data:image/png;base64,${character?.selfie}`}
                                                                alt='profile'
                                                                className='w-100 h-100 img-filter-background'
                                                            />
                                                        )}
                                                        <div className={'position-absolute gap-2 w-100 t-10px'}>
                                                            <div className={'pl-2 pr-20px'}>
                                                                <div
                                                                    className={
                                                                        'd-flex justify-content-between align-items-center'
                                                                    }
                                                                >
                                                                    <CustomCheckbox
                                                                        id={'cb_cvdc_select_' + character?.id}
                                                                        name={'selectVehicle'}
                                                                        checked={selectedList.includes(character?.id)}
                                                                        onChange={(e) => {
                                                                            handleCheckboxChange({
                                                                                target: {
                                                                                    id: character?.id,
                                                                                    checked: e.target.checked,
                                                                                    value: e.target?.value,
                                                                                },
                                                                            });
                                                                        }}
                                                                        disableRipple={true}
                                                                    />
                                                                    <CustomChip
                                                                        legend={t(status[character?.status?.id])}
                                                                        borderColor={
                                                                            statusBorderColor[character?.status?.id]
                                                                        }
                                                                        fontColor={
                                                                            statusFontColor[character?.status?.id]
                                                                        }
                                                                        background={statusColor[character?.status?.id]}
                                                                        variant={'large'}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className={'h-60px position-relative'}>
                                                        {character?.selfie ? (
                                                            <div className={'position-absolute t-50-l-50 t-0-center'}>
                                                                <img
                                                                    className={'w-120px h-120px image-card-grid'}
                                                                    src={`data:image/png;base64,${character?.selfie}`}
                                                                    alt='add'
                                                                />
                                                            </div>
                                                        ) : (
                                                            <div className={'position-absolute t-50-l-50 t-0-center'}>
                                                                <IconVehicleDefault className='h-141 w-141px' />
                                                            </div>
                                                        )}
                                                    </div>
                                                </>
                                            }
                                        >
                                            <div className='h-54px position-relative w-100'>
                                                <div className={'position-absolute t-50-l-50 w-100'}>
                                                    <CustomTooltip
                                                        text={getFullName(
                                                            character?.brand || EMPTY_VALUES.DEFAULT,
                                                            character?.subBrand || EMPTY_VALUES.DEFAULT,
                                                        )}
                                                        classes={
                                                            'ibl-h3 font-color-general-950 ibl-font-w-600 text-center text-ellipsis-2-rows'
                                                        }
                                                        showIfTruncated={true}
                                                        placement={'top'}
                                                    />
                                                </div>
                                            </div>

                                            <div className={'border-bottom-shades-300-2px'} />

                                            <div className='position-relative w-100 my-3'>
                                                <div className={'position-absolute t-50-l-50 w-100'}>
                                                    <RowCardText
                                                        icon={<ModelIcon className='w-20px' />}
                                                        title={t('model')}
                                                        value={character?.model || EMPTY_VALUES.DEFAULT}
                                                    />
                                                </div>
                                            </div>

                                            <div className='position-relative w-100 mb-3'>
                                                <div className={'position-absolute t-50-l-50 w-100'}>
                                                    <RowCardText
                                                        icon={<IconColorPalette className='w-20px' />}
                                                        title={t('color')}
                                                        value={character?.color || EMPTY_VALUES.DEFAULT}
                                                    />
                                                </div>
                                            </div>
                                            {renderVehicleButton(character)}
                                        </CustomCardGridGeneral>
                                    </div>
                                );
                            })}
                        </div>
                    </div>

                    {pagination()}
                </>
            ) : (
                <div className={'col-12 p-0'}>
                    <NotInformation text={t('no_information')} card={true} />
                </div>
            )}
        </div>
    );
});
export default ContractVehicleDetailsCards;
